import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-activity-selection-actions',
    templateUrl: './activity-selection-actions.component.html',
    standalone: false,
})
export class ActivitySelectionActionsComponent {
    @Input() public selectedCount = 0;
    @Output() public clearSelection = new EventEmitter<void>();
    @Output() public validateSelection = new EventEmitter<void>();

    public onClearSelection(event: MouseEvent): void {
        event.stopPropagation();
        this.clearSelection.emit();
    }

    public onValidateSelection(event: MouseEvent): void {
        event.stopPropagation();
        this.validateSelection.emit();
    }
}
